import React from 'react';
import {
  SelectField,
  MenuItem,
} from 'material-ui';
import ChipInput from 'material-ui-chip-input';
import {
  translate as t,
} from 'admin-on-rest';
import TextRecord from '../FormInputs/TextRecord';

export const MULTIPLE_SELECT_TYPE = 'multicorrect';
export const defaultMultipleSelect = () => {
  const randomInteger = Math.floor(Math.random() * 1000);
  const now = new Date().getTime();
  return {
    id: `${now}${randomInteger}`,
    type: MULTIPLE_SELECT_TYPE,
  };
};

const TRANSLATION_PREFIX = 'resources.quizes.fields.questions';
const TRANSLATION_QUIZ_PREFIX = 'resources.quizes.questions';

class MultipleSelectForm extends React.Component {
  isCorrectValid = (options) => {
    const currentCorrect = (this.props.correct || []);
    const currentOptions = (options || []);
    return currentCorrect.reduce(
      (previousValExists, val) => previousValExists && currentOptions.indexOf(val) < -1,
      true
    );
  }

  correctOnChange = (ev, key, payload) => {
    this.change('correct', payload);
  }

  addOption = (opt) => {
    const { options } = this.props;
    this.change('options', [...options, opt]);
  }

  removeOption = (removeOpt) => {
    const { options, id } = this.props;
    const currentCorrect = (this.props.correct || []);
    const nextOptions = options.filter((opt) => opt !== removeOpt);
    // Make sure the user wont be able to submit an object were
    // the "correct" values doesn't exist in "options"
    if (this.isCorrectValid(nextOptions)) {
      this.change('options', nextOptions);
    } else {
      const nextCorrect = currentCorrect.reduce((isInOptions, val) => {
        if (nextOptions.indexOf(val) > -1) {
          return [...isInOptions, val];
        }
        return isInOptions;
      }, []);

      this.props.onChange({
        correct: nextCorrect,
        options: nextOptions,
      }, id);
    }
  }

  optionsOnChange = (opts) => {
    this.change('options', opts);
  }

  change = (key, value) => {
    const delta = {};
    delta[key] = value;
    this.props.onChange(delta, this.props.id);
  }

  render() {
    const {
      correct, options,
      translate,
    } = this.props;

    return (
      <>
        <TextRecord
          label={translate(`${TRANSLATION_PREFIX}.type`)}
          value={translate(`${TRANSLATION_QUIZ_PREFIX}.multipleSelect`)}
        />
        <ChipInput
          value={options}
          floatingLabelText={translate(`${TRANSLATION_PREFIX}.options`)}
          // Some how this component needs all three of the below to work
          onChange={this.optionsOnChange}
          onRequestAdd={this.addOption}
          onRequestDelete={this.removeOption}
        />
        <br />
        <SelectField
          value={correct}
          multiple
          floatingLabelText={translate(`${TRANSLATION_PREFIX}.correct`)}
          onChange={this.correctOnChange}
        >
          <MenuItem />
          {
            (options || []).map((opt) => (
              <MenuItem key={opt} value={opt} primaryText={opt} />
            ))
          }
        </SelectField>
      </>
    );
  }
}

export default t(MultipleSelectForm);
